import validFileNumber from '../libraries/valid-file-number'
import commentLoad from '../libraries/comment-load'
import commentPost from '../libraries/comment-post'
import corporateSearch from '../libraries/corporate-search'
import parentStoreLoad from '../libraries/parent-store-load'
import agencyLoad from '../libraries/agency-load'
import AmountFormatter from '../libraries/amount-formatter'
import Vue from 'vue'
import bankAccountEditVue from '../components/dental_examinations/bank-account.vue'
import corporateNumberEditVue from '../components/store_examinations/corporate-number.vue'

export default {

  edit() {
    const script = document.createElement('script')
    script.src = "https://ajaxzip3.github.io/ajaxzip3.js"
    document.head.appendChild(script)

    window.card_company_select_limit = () => {
      let selected_value = []
      Array.from(document.getElementsByClassName('card_company_select')).forEach(el => {
        if (el.value === "") return
        const displayEl = el.parentNode.parentNode.parentNode
        if (document.defaultView.getComputedStyle(displayEl,null).display === "none") return
        selected_value.push(el.value)
      })
      Array.from(document.getElementsByClassName('card_company_select')).forEach(el => {
        Array.from(el.getElementsByTagName("option")).forEach(option => {
          if(option.value === "") return
          if(option.value === el.value) return
          if (selected_value.length === 0) option.disabled = false
          else option.disabled = selected_value.includes(option.value);
          if (option.selected && option.disabled) option.selected = false
        })
      })
    };

    window.e_money_company_select_limit = () => {
      let selected_value = []
      Array.from(document.getElementsByClassName('e_money_company_select')).forEach(el => {
        if (el.value === "") return
        const displayEl = el.parentNode.parentNode.parentNode
        if (document.defaultView.getComputedStyle(displayEl,null).display === "none") return
        selected_value.push(el.value)
      })
      Array.from(document.getElementsByClassName('e_money_company_select')).forEach(el => {
        Array.from(el.getElementsByTagName("option")).forEach(option => {
          if(option.value === "") return
          if(option.value === el.value) return
          if (selected_value.length === 0) option.disabled = false
          else option.disabled = selected_value.includes(option.value);
          if (option.selected && option.disabled) option.selected = false
        })
      })
    };

    window.qr_code_company_select_limit = () => {
      let selected_value = []
      Array.from(document.getElementsByClassName('qr_code_company_select')).forEach(el => {
        if (el.value === "") return
        const displayEl = el.parentNode.parentNode.parentNode
        if (document.defaultView.getComputedStyle(displayEl,null).display === "none") return
        selected_value.push(el.value)
      })
      Array.from(document.getElementsByClassName('qr_code_company_select')).forEach(el => {
        Array.from(el.getElementsByTagName("option")).forEach(option => {
          if(option.value === "") return
          if(option.value === el.value) return
          if (selected_value.length === 0) option.disabled = false
          else option.disabled = selected_value.includes(option.value);
          if (option.selected && option.disabled) option.selected = false
        })
      })
    };

    window.set_parent_store = () => {
      let idValue = ""

      const idEl = document.getElementById("store_parent_store_id")
      const txtEl = document.getElementById("parent_store_text")
      const inputValue = txtEl.value
      const addNestedFieldsBtn = document.querySelector('[data-association-insertion-node="#tag-box"]');
      const addeMoneyNestedFieldsBtn = document.querySelector('[data-association-insertion-node="#e-money-destination-form"]');
      const addQrCodeNestedFieldsBtn = document.querySelector('[data-association-insertion-node="#qr-code-destination-form"]');
      if (inputValue === "") {
        idEl.value = idValue
        if(addNestedFieldsBtn != null) {
          addNestedFieldsBtn.classList.remove('d-none');
        }
        Array.from(document.getElementsByClassName("parent_store_card_company_nested_fields")).forEach(element => {
          if(element.querySelector('.parent_store_card_company') != null) {
            element.querySelector('.parent_store_card_company').disabled = false;
          }
          if(element.querySelector('.parent_store_ratio') != null) {
            element.querySelector('.parent_store_ratio').disabled = false;
          }
          if(element.querySelector('.parent_store_agency_sales_ratio') != null) {
            element.querySelector('.parent_store_agency_sales_ratio').disabled = false;
          }
          if(element.querySelector('.parent_store_brand') != null && element.querySelector('.parent_store_brand').value === '') {
              element.querySelector('.parent_store_brand').options[0].textContent = '';
              element.querySelector('.parent_store_brand').selected = true;
          }
          if(element.querySelector('.d-none') != null) {
            element.querySelector('.d-none').classList.remove('d-none')
          }
        });

        if(addeMoneyNestedFieldsBtn != null) {
          addeMoneyNestedFieldsBtn.classList.remove('d-none');
        }
        Array.from(document.getElementsByClassName("parent_store_e_money_company_nested_fields")).forEach(element => {
          if(element.querySelector('.parent_store_e_money_company') != null) {
            element.querySelector('.parent_store_e_money_company').disabled = false;
          }
          if(element.querySelector('.parent_store_e_money_ratio') != null) {
            element.querySelector('.parent_store_e_money_ratio').disabled = false;
          }
          if(element.querySelector('.parent_store_e_money_agency_sales_ratio') != null) {
            element.querySelector('.parent_store_e_money_agency_sales_ratio').disabled = false;
          }
          if(element.querySelector('.parent_store_e_money_brand') != null && element.querySelector('.parent_store_e_money_brand').value === '') {
              element.querySelector('.parent_store_e_money_brand').options[0].textContent = '';
              element.querySelector('.parent_store_e_money_brand').selected = true;
          }
          if(element.querySelector('.d-none') != null) {
            element.querySelector('.d-none').classList.remove('d-none')
          }
        });

        if(addQrCodeNestedFieldsBtn != null) {
          addQrCodeNestedFieldsBtn.classList.remove('d-none');
        }
        Array.from(document.getElementsByClassName("parent_store_qr_code_company_nested_fields")).forEach(element => {
          if(element.querySelector('.parent_store_qr_code_company') != null) {
            element.querySelector('.parent_store_qr_code_company').disabled = false;
          }
          if(element.querySelector('.parent_store_qr_code_ratio') != null) {
            element.querySelector('.parent_store_qr_code_ratio').disabled = false;
          }
          if(element.querySelector('.parent_store_qr_code_agency_sales_ratio') != null) {
            element.querySelector('.parent_store_qr_code_agency_sales_ratio').disabled = false;
          }
          if(element.querySelector('.parent_store_qr_code_brand') != null && element.querySelector('.parent_store_qr_code_brand').value === '') {
              element.querySelector('.parent_store_qr_code_brand').options[0].textContent = '';
              element.querySelector('.parent_store_qr_code_brand').selected = true;
          }
          if(element.querySelector('.d-none') != null) {
            element.querySelector('.d-none').classList.remove('d-none')
          }
        })

        // 決済条件 - 契約タイプ - 親加盟店が空文字の場合、「2回締め」「1ヶ月締め」のみ編集可能にする。
        const store_dental_attributes_contract_type = document.getElementById('store_dental_attributes_contract_type');
        if(store_dental_attributes_contract_type != null) {
          store_dental_attributes_contract_type.disabled = false;
          store_dental_attributes_contract_type.querySelector('[value="week_thu_mon"]').disabled = true;
          store_dental_attributes_contract_type.querySelector('[value="contract_friday"]').disabled = true;
          store_dental_attributes_contract_type.querySelector('[value="week_mon_sun"]').disabled = true;
          store_dental_attributes_contract_type.querySelector('[value="five_days"]').disabled = true;
          if(store_dental_attributes_contract_type.value !== 'twice_per_month' && store_dental_attributes_contract_type.value !== 'monthly') {
            store_dental_attributes_contract_type.value = 'twice_per_month';  // デフォルトは「2回締め」。
          }
        }
        // 決済条件 - 振込手数料単価
        const store_dental_attributes_fixed_cost = document.getElementById('store_dental_attributes_fixed_cost');
        if(store_dental_attributes_fixed_cost != null) {
          store_dental_attributes_fixed_cost.disabled = false;
        }
        // 決済条件 - 支払種別
        const store_dental_attributes_payment_source = document.getElementById('store_dental_attributes_payment_source');
        if(store_dental_attributes_payment_source != null) {
          store_dental_attributes_payment_source.disabled = false;
        }
        // 決済条件 - 請求種別
        // TODO: store_examinations.jsと処理が違うので、時間のある時に統一したい
        const store_dental_attributes_billing_type = document.getElementById('store_dental_attributes_billing_type');
        if(store_dental_attributes_billing_type != null) {
          store_dental_attributes_billing_type.disabled = false;
        }
        return
      }

      const masterListEl = document.getElementById("parent_store_master_list")
      Array.from(masterListEl.getElementsByTagName("option")).forEach(option => {
        if(option.value == inputValue) idValue = option.innerText
      })
      if(idValue == "") txtEl.value = ""
      else {
        let token = ''
        Array.from(document.getElementsByTagName('meta')).forEach(meta => {
          if (meta.name != 'csrf-token') return
          token = meta.content
        })
        parentStoreLoad(idValue, token)
        Array.from(document.getElementsByClassName("parent_store_item")).forEach(element => {
          element.disabled = true
        });
        Array.from(document.getElementsByClassName("parent_store_brand")).forEach(element => {
          element.disabled = false
        });
        Array.from(document.getElementsByClassName("parent_store_e_money_brand")).forEach(element => {
          element.disabled = false
        });
        if(addNestedFieldsBtn != null) {
          addNestedFieldsBtn.classList.add('d-none');
        }
        if(addeMoneyNestedFieldsBtn != null) {
          addeMoneyNestedFieldsBtn.classList.add('d-none');
        }
        if(addQrCodeNestedFieldsBtn != null) {
          addQrCodeNestedFieldsBtn.classList.add('d-none');
        }
      }
      idEl.value = idValue
    };

    window.set_agency = () => {
      let idValue = ""
      const idEl = document.getElementById("store_agency_id")
      idValue = idEl.value

      if (idValue !== "") {
        let token = ''
        let parentStoreStatus = null

        Array.from(document.getElementsByTagName('meta')).forEach(meta => {
          if (meta.name != 'csrf-token') return
          token = meta.content
        })

        const txtEl = document.getElementById("parent_store_text")
        const inputValue = txtEl.value
        if (inputValue !== "") {
          parentStoreStatus = true
        } else {
          parentStoreStatus = false
        }

        agencyLoad(idValue, token, "dental", parentStoreStatus, "change")
      } else if (idValue === "") {
        if (document.getElementById("parent_store_text").value === "") {
          Array.from(document.getElementsByClassName("parent_store_card_company_nested_fields")).forEach(element => {
            element.querySelector('.parent_store_brand').value = 0;
            element.querySelector('input[type="hidden"]').value = 1;
            element.style.display = 'none';
          });
          Array.from(document.getElementsByClassName("parent_store_e_money_company_nested_fields")).forEach(element => {
            element.querySelector('.parent_store_e_money_brand').value = 0;
            element.querySelector('input[type="hidden"]').value = 1;
            element.style.display = 'none';
          });
        } else {
          Array.from(document.getElementsByClassName("parent_store_card_company_nested_fields")).forEach(element => {
            element.querySelector('.parent_store_brand').value = 0;
          });
          Array.from(document.getElementsByClassName("parent_store_e_money_company_nested_fields")).forEach(element => {
            element.querySelector('.parent_store_e_money_brand').value = 0;
          });
        }
      }
    };

    document.addEventListener('DOMContentLoaded', () => {

      new Vue({
        el: '#edit_corporate_number',
        render: h => h(corporateNumberEditVue)
      })

      // Vue コンポーネント内外で要素を相互参照していて気持ち悪いが、動きはするので良いことにする。
      corporateSearch.activate({
        corporateNumber: document.querySelector("#store_corporation_attributes_number"),
        name: document.querySelector("#store_corporation_attributes_name"),
        nameKana: document.querySelector("#store_corporation_attributes_name_kana"),
        postCode: document.querySelector("#store_corporation_attributes_zip_code"),
        prefecture: document.querySelector("#store_corporation_attributes_state"),
        city: document.querySelector("#store_corporation_attributes_city"),
        street: document.querySelector("#store_corporation_attributes_street"),
      })
      document.querySelector("#copy-corporate-search-results").addEventListener("click", corporateSearch.copyResultValuesToInput)

      const doTranscribe = document.querySelector("#do-transcribe")
      doTranscribe && doTranscribe.addEventListener("click", e => {
        if (!window.confirm("通常加盟店への転記申請を行いますか？")) return

        const form = document.createElement("form")
        form.action = e.target.dataset.url
        form.method = "post"
        form.style = "overflow: hidden; width: 0; height: 0;"

        const token = document.createElement("input")
        token.setAttribute
        token.setAttribute("type", "hidden")
        token.setAttribute("name", document.querySelector("meta[name=csrf-param][content]").content)
        token.setAttribute("value", document.querySelector("meta[name=csrf-token][content]").content)
        form.appendChild(token)

        document.body.appendChild(form)
        form.submit()
      })

      new Vue({
        el: '#edit_bank_account',
        render: h => h(bankAccountEditVue)
      })

      Array.from(document.getElementsByTagName('input')).forEach(element => {
        if (element.type != 'text') return
        element.addEventListener('keypress', () => {
          if (event.keyCode == 13) {
            event.preventDefault()
          }
        })
      })

      Array.from(document.getElementsByClassName('zip-search-btn')).forEach(element => {
        element.addEventListener('click', () => {
          const zip_code = element.previousElementSibling
          const state = document.getElementsByName(zip_code.name.replace('[zip_code]', '[state]'))[0]
          const city = document.getElementsByName(zip_code.name.replace('[zip_code]', '[city]'))[0]
          const street = document.getElementsByName(zip_code.name.replace('[zip_code]', '[street]'))[0]
          AjaxZip3.zip2addr(zip_code, '', state.name, city.name, street.name)
        })
      })

      Array.from(document.getElementsByName('store[corporation_attributes][corporation_flg]')).forEach(el => {
        Array.from(document.getElementsByClassName('corporation_area')).forEach(area => {
          area.style.display = el.value === "true" ? "" : "none"
        })
        el.addEventListener('change', (e) => {
          Array.from(document.getElementsByClassName('corporation_area')).forEach(area => {
            area.style.display = el.value === "true" ? "" : "none"
          })
        })
      })

      Array.from(document.getElementsByName('store[parent_store_id]')).forEach(el => {
        if (el.value !== "") {
          let token = ''
          Array.from(document.getElementsByTagName('meta')).forEach(meta => {
            if (meta.name != 'csrf-token') return
            token = meta.content
          })
          parentStoreLoad(el.value, token)
          Array.from(document.getElementsByClassName("parent_store_item")).forEach(element => {
            element.disabled = true
          });
          Array.from(document.getElementsByClassName("parent_store_brand")).forEach(element => {
            element.disabled = false
          });
          Array.from(document.getElementsByClassName("parent_store_e_money_brand")).forEach(element => {
            element.disabled = false
          });
          const addNestedFieldsBtn = document.querySelector('[data-association-insertion-node="#tag-box"]');
          if(addNestedFieldsBtn != null) {
            addNestedFieldsBtn.classList.add('d-none');
          }
          const addeMoneyNestedFieldsBtn = document.querySelector('[data-association-insertion-node="#e-money-destination-form"]');
          if(addeMoneyNestedFieldsBtn != null) {
            addeMoneyNestedFieldsBtn.classList.add('d-none');
          }
          const addQrCodeNestedFieldsBtn = document.querySelector('[data-association-insertion-node="#qr-code-destination-form"]');
          if(addQrCodeNestedFieldsBtn != null) {
            addQrCodeNestedFieldsBtn.classList.add('d-none');
          }
        } else {
          // 決済条件 - 契約タイプ - 初期表示で親加盟店が空文字の場合、「2回締め」「1ヶ月締め」のみ編集可能にする。
          const store_dental_attributes_contract_type = document.getElementById('store_dental_attributes_contract_type');
          if(store_dental_attributes_contract_type != null) {
            store_dental_attributes_contract_type.querySelector('[value="week_thu_mon"]').disabled = true;
            store_dental_attributes_contract_type.querySelector('[value="contract_friday"]').disabled = true;
            store_dental_attributes_contract_type.querySelector('[value="week_mon_sun"]').disabled = true;
            store_dental_attributes_contract_type.querySelector('[value="five_days"]').disabled = true;
          }
        }
      })

      Array.from(document.getElementsByName('store[agency_id]')).forEach(el => {
        if (el.value !== "") {
          let token = ''
          let parentStoreStatus = null

          Array.from(document.getElementsByTagName('meta')).forEach(meta => {
            if (meta.name != 'csrf-token') return
            token = meta.content
          })

          const txtEl = document.getElementById("parent_store_text")
          const inputValue = txtEl.value
          if (inputValue !== "") {
            parentStoreStatus = true
          } else {
            parentStoreStatus = false
          }

          agencyLoad(el.value, token, "dental", parentStoreStatus, "load")
        }
      })

      Array.from(document.getElementsByClassName("parent_store_card_company_nested_fields")).forEach(element => {
        element.querySelector('.btn-delete').addEventListener('click', () => {
          element.querySelector('.parent_store_brand').value = 0;
        })
      })

      Array.from(document.getElementsByClassName('upload_delete')).forEach(el => {
        el.addEventListener('click', (e) => {
          el.parentNode.parentNode.style.display = "none"
        })
      })

      const examination_keeping_card_info = document.getElementById('store_dental_attributes_dental_examination_attributes_keeping_card_info')
      if (examination_keeping_card_info !== null) {
        const examination_no_card_info_date = document.getElementById('store_dental_attributes_dental_examination_attributes_no_card_info_date')
        const examination_pcidss_info = document.getElementById('store_dental_attributes_dental_examination_attributes_pcidss_info')
        const examination_pcidss_date = document.getElementById('store_dental_attributes_dental_examination_attributes_pcidss_date')
        const examination_device_ic_info = document.getElementById('store_dental_attributes_dental_examination_attributes_device_ic_info')
        const examination_device_ic_date = document.getElementById('store_dental_attributes_dental_examination_attributes_device_ic_date')

        const pcidss_area = document.getElementsByClassName('pcidss_area')[0]

        if (examination_keeping_card_info.value !== "2") {
          examination_no_card_info_date.value = null
          examination_no_card_info_date.readOnly = true
        }
        if (examination_keeping_card_info.value !== "1") {
          pcidss_area.style.display = "none"
          Array.from(examination_pcidss_info.getElementsByTagName("option")).forEach(option => {
            if(option.selected === true) option.selected = false
          })
          examination_pcidss_date.value = null
          examination_pcidss_date.readOnly = true
        }
        examination_keeping_card_info.addEventListener('change', (e) => {
          if (examination_keeping_card_info.value !== "2") {
            examination_no_card_info_date.value = null
            examination_no_card_info_date.readOnly = true
          } else {
            examination_no_card_info_date.readOnly = false
          }

          if (examination_keeping_card_info.value !== "1") {
            pcidss_area.style.display = "none"
            Array.from(examination_pcidss_info.getElementsByTagName("option")).forEach(option => {
              if(option.selected === true) option.selected = false
            })
            examination_pcidss_date.value = null
            examination_pcidss_date.readOnly = true
          } else {
            pcidss_area.style.display = ""
          }
        })

        if (examination_pcidss_info.value !== "2") {
          examination_pcidss_date.value = null
          examination_pcidss_date.readOnly = true
        }
        examination_pcidss_info.addEventListener('change', (e) => {
          if (examination_pcidss_info.value !== "2") {
            examination_pcidss_date.value = null
            examination_pcidss_date.readOnly = true
          } else {
            examination_pcidss_date.readOnly = false
          }
        })

        if (examination_device_ic_info.value !== "2") {
          examination_device_ic_date.readOnly = true
        }
        examination_device_ic_info.addEventListener('change', (e) => {
          if (examination_device_ic_info.value !== "2") {
            examination_device_ic_date.value = null
            examination_device_ic_date.readOnly = true
          } else {
            examination_device_ic_date.readOnly = false
          }
        })
      }

      const store_id = document.getElementById('store_id').value
      let token = ''
      Array.from(document.getElementsByTagName('meta')).forEach(meta => {
        if (meta.name != 'csrf-token') return
        token = meta.content
      })

      commentLoad(store_id, token, 30)
      commentPost(store_id, token)

      Array.from(document.getElementsByClassName('comment-reload')).forEach(el => {
        el.addEventListener('click', (e) => {
          commentLoad(store_id, token, 30)
        })
      })

      const form = document.querySelector('form[data="update"]');
      form.addEventListener('submit', (event) => {
        // Salesforce ID 未入力時で保存時に警告表示
        const account_id = document.getElementById('store_sf_account_id').value
        const opportunity_id = document.getElementById('store_sf_opportunity_id').value
        const contact_id = document.getElementById('store_sf_contact_id').value
        const is_dummy_store = document.getElementById('store_dental_attributes_is_dummy_store').checked
        const message = [
          'Salesforce ID が入力されていません。',
          'このまま保存すると、Salesforce 上に新しいデータが追加されます。',
          '',
          '処理を続行しますか？',
        ].join("\n")
        // ダミー歯科加盟店の場合は商談 ID を評価しない
        if (!(account_id && (is_dummy_store || opportunity_id) && contact_id) && !window.confirm(message)) {
          event.stopPropagation()
          event.preventDefault()
          return false
        }

        // Clear disabled attributes in 連携先 before submit.
        const cardCompanyElms = document.getElementsByClassName('parent_store_card_company');
        for(let i = 0; i < cardCompanyElms.length; i++) {
          cardCompanyElms[i].disabled = false;
        }
        const eMoneyCompanyElms = document.getElementsByClassName('parent_store_e_money_company');
        for(let i = 0; i < eMoneyCompanyElms.length; i++) {
          eMoneyCompanyElms[i].disabled = false;
        }
        const qrCodeCompanyElms = document.getElementsByClassName('parent_store_qr_code_company');
        for(let i = 0; i < qrCodeCompanyElms.length; i++) {
          qrCodeCompanyElms[i].disabled = false;
        }
        const ratioElms = document.getElementsByClassName('parent_store_ratio');
        for(let i = 0; i < ratioElms.length; i++) {
          ratioElms[i].disabled = false;
        }
        const agencyRatioElms = document.getElementsByClassName('parent_store_agency_sales_ratio');
        for(let i = 0; i < agencyRatioElms.length; i++) {
          agencyRatioElms[i].disabled = false;
        }
      });

      const rabbitAccountIssuedBtn = document.querySelector('.rabbit-account-issued-btn')
      if (rabbitAccountIssuedBtn) {
        rabbitAccountIssuedBtn.addEventListener('click', (e) => {
          const email = document.getElementById('store_dental_attributes_email').value;
          if (!confirm(`メールアドレス「${email}」でRabbitアカウントを発行しますか？`)) return
          
          const form = document.createElement("form");
          form.action = e.target.dataset.url;
          form.method = "post";
          form.style = "overflow: hidden; width: 0; height: 0;";

          // メールパラメータの追加
          const emailInput = document.createElement("input");
          emailInput.setAttribute("type", "hidden");
          emailInput.setAttribute("name", "email");
          emailInput.setAttribute("value", email);
          form.appendChild(emailInput);

          const token = document.createElement("input");
          token.setAttribute("type", "hidden");
          token.setAttribute(
            "name",
            document.querySelector("meta[name=csrf-param][content]").content
          );
          token.setAttribute(
            "value",
            document.querySelector("meta[name=csrf-token][content]").content
          );
          form.appendChild(token);

          document.body.appendChild(form);
          form.submit();
        })
      }

      // 金額にカンマを付けるライブラリをインポート
      new AmountFormatter().Run();
    })
  },

  show() {
    document.addEventListener('DOMContentLoaded', () => {

      document.getElementById("submitter").innerHTML = "";

      Array.from(document.getElementsByTagName("input")).forEach(el => {
        if(el.type === "hidden") return;
        if(el.type === "radio") {
          if(!el.checked) el.disabled = "disabled"
        }
        el.readOnly = true
      })

      Array.from(document.getElementsByTagName("select")).forEach(el => {
        Array.from(el.getElementsByTagName("option")).forEach(option => {
          if(!option.selected) option.disabled = "disabled"
        })
      })

      Array.from(document.getElementsByTagName("button")).forEach(el => {
        el.style = "display:none"
      })

      Array.from(document.getElementsByTagName("textarea")).forEach(el => {
        if(el.id === "term_of_service") return
        el.readOnly = true
      })
      Array.from(document.getElementsByClassName("comment-input")).forEach(el => {
        el.readOnly = false
      })

      commentLoad(store_id, token, 30)
      commentPost(store_id, token)

      Array.from(document.getElementsByClassName('comment-reload')).forEach(el => {
        el.addEventListener('click', (e) => {
          commentLoad(store_id, token, 30)
        })
      })

    })
  }

}
